<template>
  <div id="contenedor-ejecucion-configuracion-firmas-nueva">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevaFirma">
      <auto-complete
        v-model="firma.idFuncionario"
        label="Funcionario"
        :items="getFuncionarios"
        item-text="nombre"
        item-value="id"
        :rules="[mixReglas.requerido]">
      </auto-complete>
      <custom-text-field
        v-model.number="firma.orden"
        type="number"
        label="Orden"
        :rules="[mixReglas.requerido]">
      </custom-text-field>
    </v-form>
  </div>
</template>

<script>
import AGREGAR_FIRMA from '@/graphql/mutations/administracion/configuracion/firmas/agregarFirma.gql';
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import Funcionarios from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import AutoComplete from '@/components/inputs/Autocomplete.vue';
import CustomTextField from '@/components/inputs/TextField.vue';

export default {
  name: 'EjeucionConfiguracionFirmasNueva',
  components: {
    AutoComplete,
    CustomTextField,
  },
  props: {
    modulo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      firma: {
        idFuncionario: '',
        modulo: this.modulo,
        orden: 1,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevaFirma.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      const { firma } = this;

      this.enviadoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_FIRMA,
          variables: {
            firma,
          },
          update: (store, { data: { agregarFirma } }) => {
            const data = store.readQuery({
              query: FIRMAS_POR_MODULO,
              variables: {
                modulo: this.modulo,
              },
            });
            data.firmasPorModulo.push(agregarFirma);
            store.writeQuery({
              query: FIRMAS_POR_MODULO,
              data,
            });
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviadoFormulario = false;
    },
  },
  apollo: {
    funcionarios: {
      query: Funcionarios,
    },
  },
  computed: {
    getFuncionarios() {
      if (!this.funcionarios) return [];
      return this.funcionarios;
    },
  },
};
</script>

<style lang="scss">

</style>
